import React, { useState } from 'react'

import styled from 'styled-components'

import { Box, Modal } from 'app/components/design-system-components'
import { Button } from 'app/components/design-system-components'
import { Input } from 'app/components/design-system-components/inputs'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

const DEACTIVATE_PHRASE = 'DEACTIVATE'

const StyledUL = styled.ul`
  margin-left: ${theme.space[4]}px !important;
  padding-left: ${theme.space[4]}px !important;
  li {
    display: list-item;
  }
`

interface GroupBundleDeactivateModalProps {
  onConfirm: () => void
  toggleConfirmDeactivateGroupBundleModal: () => void
}

function GroupBundleDeactivateModal({
  onConfirm,
  toggleConfirmDeactivateGroupBundleModal,
}: GroupBundleDeactivateModalProps) {
  const [isDisableDeactivate, setIsDisableDeactivate] = useState(true)

  const checkForCorrectDeactivatePhrase = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { target } = event
    const { value } = target
    if (value === DEACTIVATE_PHRASE) {
      setIsDisableDeactivate(false)
    } else {
      setIsDisableDeactivate(true)
    }
  }
  return (
    <Modal
      modalHeading="Deactivating features"
      modalBody={
        <Box style={{ lineHeight: theme.lineHeights.encrption }} mt={3} mb={6}>
          <Box mb={5}>
            <Text m={0}>
              This will disable this bundle and permanently remove any
              configuration for the following features when Update Profile is
              clicked:
            </Text>
            <StyledUL>
              <li>Group reporting</li>
              <li>Group prospecting</li>
              <li>Pods</li>
              <li>
                Multiple trust accounts (only first Trust Account will be
                retained)
              </li>
            </StyledUL>
          </Box>
          <Text mb={4}>Confirm by typing DEACTIVATE below.</Text>
          <Input
            inputProps={{
              placeholder: 'type DEACTIVATE',
              onChange: checkForCorrectDeactivatePhrase,
            }}
            width={theme.width[10] + 'px'}
            height={theme.dividedSpace[10] + 'px'}
            id={undefined}
            icon={undefined}
            prefix={undefined}
            postfix={undefined}
            endedIcon={undefined}
            containerProps={undefined}
          />
        </Box>
      }
      showPrimaryButton={false}
      showSecondaryButton={false}
      primaryLabel={undefined}
      primaryAction={undefined}
      secondaryLabel={undefined}
      secondaryAction={undefined}
      toggleModal={toggleConfirmDeactivateGroupBundleModal}
      customModalFooter={true}
      modalFooter={
        <Button
          disabled={isDisableDeactivate}
          sizeVariant="regular"
          width={theme.width[14] + 'px'}
          onClick={onConfirm}
        >
          Deactivate
        </Button>
      }
    />
  )
}

export default GroupBundleDeactivateModal
